import React from "react"
import "./styles.scss"
const ClutchBadge = ({ title, image }) => {
  return (
    <div className="clutchBadge">
      <img
        src={image}
        alt="Clutch badge image"
        className="clutchBadge__image"
      />
      <span className="clutchBadge__title">{title}</span>
    </div>
  )
}

export default ClutchBadge
